export interface Comic {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  status: string;
  chapters: number;
  rating: number;
  readers: string;
  description: string;
  cover: string;
}

export const genres = [
  "全部",
  "热血冒险",
  "玄幻奇幻",
  "都市生活",
  "悬疑推理",
  "治愈日常",
  "科幻机甲",
  "武侠古风",
];

export const comics: Comic[] = [
  {
    id: "jian-xing-chen",
    title: "剑与星辰",
    author: "夜半听雨",
    genre: "玄幻奇幻",
    tags: ["热血", "修行", "成长"],
    status: "连载中",
    chapters: 236,
    rating: 9.2,
    readers: "1280万",
    description: "废柴少年意外觉醒星辰剑意，踏上逆天改命之路，斩尽黑暗，问鼎九霄。",
    cover: "https://readdy.ai/api/search-image?query=A%20dynamic%20wuxia%20fantasy%20comic%20cover%20of%20a%20young%20swordsman%20wielding%20a%20glowing%20star%20blade%20on%20a%20mountain%20peak%20at%20dusk%2C%20warm%20orange%20and%20gold%20energy%20particles%2C%20dramatic%20manga%20illustration%20style%2C%20rich%20ink%20linework%2C%20cinematic%20lighting%2C%20energetic%20composition&width=600&height=900&seq=comic-jianxingchen-01&orientation=portrait",
  },
  {
    id: "dou-shi-lian-jin",
    title: "都市炼金师",
    author: "白桃乌龙",
    genre: "都市生活",
    tags: ["轻松", "日常", "奇遇"],
    status: "连载中",
    chapters: 168,
    rating: 8.8,
    readers: "960万",
    description: "平凡上班族捡到一本炼金手记，从此在都市中展开一段奇妙又温暖的日常冒险。",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20urban%20slice-of-life%20comic%20cover%20of%20a%20young%20office%20worker%20with%20glowing%20alchemy%20symbols%20floating%20around%20him%20in%20a%20cozy%20city%20cafe%2C%20golden%20amber%20lighting%2C%20soft%20manga%20style%2C%20gentle%20cute%20energy%2C%20warm%20tones&width=600&height=900&seq=comic-doushi-01&orientation=portrait",
  },
  {
    id: "mao-niang-kuai-di",
    title: "猫娘快递",
    author: "芒果慕斯",
    genre: "都市生活",
    tags: ["萌系", "搞笑", "治愈"],
    status: "连载中",
    chapters: 312,
    rating: 9.0,
    readers: "1540万",
    description: "深夜猫娘快递员穿梭城市送温暖，每一单背后都藏着一个令人会心一笑的小故事。",
    cover: "https://readdy.ai/api/search-image?query=A%20cute%20heartwarming%20comic%20cover%20of%20a%20cat-eared%20girl%20courier%20on%20a%20scooter%20under%20a%20night%20city%20with%20warm%20streetlights%2C%20playful%20chibi%20manga%20style%2C%20soft%20orange%20glow%2C%20cozy%20and%20humorous%20mood%2C%20vibrant%20colors&width=600&height=900&seq=comic-maoniang-01&orientation=portrait",
  },
  {
    id: "ji-jia-ji-yuan",
    title: "机甲纪元",
    author: "灰烬骑士",
    genre: "科幻机甲",
    tags: ["科幻", "机甲", "战斗"],
    status: "连载中",
    chapters: 204,
    rating: 9.4,
    readers: "1730万",
    description: "人类最后防线，少年机师驾驶传说机甲对抗外星入侵，为家园而战。",
    cover: "https://readdy.ai/api/search-image?query=A%20sci-fi%20mecha%20comic%20cover%20of%20a%20heroic%20pilot%20in%20a%20giant%20orange%20robot%20suit%20against%20a%20fiery%20apocalyptic%20sky%2C%20dramatic%20manga%20illustration%2C%20warm%20embers%20and%20smoke%2C%20epic%20scale%2C%20high%20detail%20mech%20design&width=600&height=900&seq=comic-jijia-01&orientation=portrait",
  },
  {
    id: "shan-yue-jiang-hu",
    title: "山月江湖",
    author: "青竹剑客",
    genre: "武侠古风",
    tags: ["武侠", "江湖", "恩怨"],
    status: "已完结",
    chapters: 158,
    rating: 9.1,
    readers: "1120万",
    description: "一段少年执剑闯江湖的传奇，快意恩仇之间，藏着家国与道义的抉择。",
    cover: "https://readdy.ai/api/search-image?query=A%20classical%20wuxia%20comic%20cover%20of%20a%20young%20hero%20with%20a%20sword%20standing%20under%20a%20bright%20moon%20in%20a%20mountain%20forest%2C%20traditional%20Chinese%20painting%20meets%20modern%20manga%20style%2C%20warm%20moonlight%20and%20autumn%20leaves%2C%20poetic%20and%20elegant&width=600&height=900&seq=comic-shanyue-01&orientation=portrait",
  },
  {
    id: "xing-ji-ka-fei",
    title: "星际咖啡馆",
    author: "银河小筑",
    genre: "治愈日常",
    tags: ["治愈", "温馨", "日常"],
    status: "连载中",
    chapters: 142,
    rating: 9.3,
    readers: "880万",
    description: "在银河尽头的咖啡馆里，每个人都能找到一杯属于自己的暖心故事。",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20healing%20comic%20cover%20of%20a%20space%20cafe%20with%20a%20warm%20glowing%20interior%2C%20a%20barista%20serving%20coffee%20under%20a%20starry%20window%2C%20soft%20golden%20light%2C%20gentle%20relaxing%20manga%20style%2C%20dreamy%20warm%20tones&width=600&height=900&seq=comic-xingji-01&orientation=portrait",
  },
  {
    id: "yue-xia-zhen-tan",
    title: "月下侦探社",
    author: "夜莺先生",
    genre: "悬疑推理",
    tags: ["推理", "悬疑", "都市"],
    status: "连载中",
    chapters: 96,
    rating: 8.9,
    readers: "760万",
    description: "只在夜晚营业的侦探社，接手的每桩案件都藏着月影之下的秘密。",
    cover: "https://readdy.ai/api/search-image?query=A%20noir%20mystery%20comic%20cover%20of%20a%20detective%20silhouette%20with%20a%20magnifying%20glass%20under%20a%20large%20full%20moon%2C%20moody%20warm%20lamplight%2C%20dark%20shadows%20with%20amber%20highlights%2C%20atmospheric%20manga%20style%2C%20suspenseful&width=600&height=900&seq=comic-yuexia-01&orientation=portrait",
  },
  {
    id: "tian-pin-wu-shi",
    title: "甜品屋物语",
    author: "奶油小兔",
    genre: "治愈日常",
    tags: ["美食", "治愈", "轻松"],
    status: "已完结",
    chapters: 178,
    rating: 9.5,
    readers: "1390万",
    description: "一间小小甜品屋，治愈着每位客人，也治愈着店主自己慢慢敞开的内心。",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20dessert%20comic%20cover%20of%20a%20cute%20patisserie%20with%20colorful%20cakes%20and%20pastries%20on%20display%2C%20a%20smiling%20chef%20behind%20the%20counter%2C%20warm%20cream%20and%20caramel%20tones%2C%20soft%20cozy%20manga%20style%2C%20mouthwatering%20and%20gentle&width=600&height=900&seq=comic-tianpin-01&orientation=portrait",
  },
  {
    id: "lie-mo-ren-bi-ji",
    title: "猎魔人笔记",
    author: "绯色之刃",
    genre: "热血冒险",
    tags: ["热血", "魔幻", "战斗"],
    status: "连载中",
    chapters: 221,
    rating: 9.0,
    readers: "1010万",
    description: "当代猎魔人继承祖辈笔记，在繁华都市中对抗潜伏的魔物，守护人间安宁。",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20hunter%20comic%20cover%20of%20a%20cloaked%20huntress%20holding%20a%20rune-covered%20notebook%20and%20a%20blade%2C%20fiery%20warm%20torchlight%20against%20dark%20ruins%2C%20dramatic%20manga%20style%2C%20intense%20high-contrast%20lighting&width=600&height=900&seq=comic-liemo-01&orientation=portrait",
  },
  {
    id: "wu-xing-shao-nian",
    title: "五行少年",
    author: "九重塔",
    genre: "热血冒险",
    tags: ["修行", "热血", "冒险"],
    status: "连载中",
    chapters: 187,
    rating: 8.7,
    readers: "690万",
    description: "身负五行之力的少年们结伴而行，寻宝历练，揭开封印千年的古老秘密。",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20cultivation%20comic%20cover%20of%20five%20teenagers%20with%20elemental%20powers%20&width=600&height=900&seq=comic-wuxing-01&orientation=portrait(metal%2C%20wood%2C%20water%2C%20fire%2C%20earth)%20surrounded%20by%20glowing%20warm%20spirit%20energy%2C%20dynamic%20manga%20style%2C%20epic%20adventure%20mood%2C%20rich%20orange%20and%20gold%20tones",
  },
];

export const featuredComics = comics.slice(0, 4);

export const readingModes = [
  {
    icon: "ri-book-open-line",
    title: "翻页阅读",
    desc: "模拟实体书的翻页体验，左右滑动切换页面，节奏由你掌控，重温翻阅纸页的熟悉感。",
  },
  {
    icon: "ri-arrow-down-line",
    title: "下拉阅读",
    desc: "像刷信息流一样向下滑动连续阅读，无需频繁点按，沉浸式追更一气呵成。",
  },
  {
    icon: "ri-list-unordered",
    title: "目录跳转",
    desc: "章节目录一目了然，一键直达任意章节与分镜，快速定位，追更不迷路。",
  },
  {
    icon: "ri-moon-line",
    title: "夜间模式",
    desc: "深夜追更更护眼，暖色夜间模式自动降亮度，字画清晰不刺眼，看得再久也不累。",
  },
  {
    icon: "ri-download-cloud-line",
    title: "离线缓存",
    desc: "一键缓存整部作品，地铁、高铁、电梯里没网也能看，精彩从不缺席。",
  },
  {
    icon: "ri-fullscreen-line",
    title: "横屏阅读",
    desc: "支持横屏全屏双开，翻页与跨页大图更震撼，追大场面分镜效果拉满。",
  },
];